import { fetchApi } from '@/config/axiosSetting.ts';
import { PostBodyVehicleCorrectiveImagesType } from '@/modules/adjusterReportModules/Insurer-information/queries/postBodyVehicleCorrectiveImages/postBodyVehicleCorrectiveImages.type';
import { AxiosResponse } from 'axios';

export const postBodyVehicleCorrectiveImagesFunction = ({
  body,
  id,
}: PostBodyVehicleCorrectiveImagesType): Promise<AxiosResponse<any, any>> => {
  return fetchApi({
    method: 'post',
    url: `/body/reports/${id}/images/corrective/send/request/`,
    data: body,
  });
};
